import api from '~/services/api';

export type TermType = 'General' | 'Warranty' | 'TrackingService';

export interface OrganizationTermsOfUseResponse {
  id: number;
  organizationId: string;
  termType: string;
  title: string;
  content: string;
  version: number;
  effectiveFrom: string;
  createDate: string;
  updateDate: string;
}

/**
 * Busca os termos de uso da organização na API.
 * Rota: GET /v2/OrganizationTermsOfUse/{termType}
 * Query: ?organization_id=xxx quando informado (conforme org na URL da aplicação).
 * Retorna o campo content (markdown) do objeto de resposta.
 */
export async function getOrganizationTermsOfUse(termType: TermType, organizationId?: string | null): Promise<string> {
  if (!api.v2) {
    throw new Error('API v2 não está disponível');
  }
  const params = organizationId ? { organization_id: organizationId } : undefined;
  const { data } = await api.v2.get<OrganizationTermsOfUseResponse | { data: OrganizationTermsOfUseResponse }>(
    `/OrganizationTermsOfUse/${termType}`,
    { params }
  );
  const payload = (data && 'data' in data && data.data ? data.data : data) as OrganizationTermsOfUseResponse;
  return typeof payload?.content === 'string' ? payload.content : '';
}
